export function shouldHydrateRoot(root: Element): boolean {
  return root.childElementCount > 0;
}
